module.exports = __webpack_public_path__ + "static/media/26.c7375b29.png";